'use strict';
const mapThemes = require('@mindmup/mapjs-core/src/themes/index');
module.exports = function GoldMapCreatorModel(config, navigatorModel) {
	const self = this,
		createFrom = function (theme) {
			navigatorModel.redirect(`${config.editorUrl}/new?theme=${theme}`);
		};
	Object.keys(mapThemes).forEach(theme => self[theme] = () => createFrom(theme));
};
